var exports = {
  "zr": "MacPermissionPrompt.module__root___UjNzNU",
  "Vs": "MacPermissionPrompt.module__tile___UjNzNU",
  "DD": "MacPermissionPrompt.module__title___UjNzNU",
  "X7": "MacPermissionPrompt.module__purpose___UjNzNU",
  "vQ": "MacPermissionPrompt.module__purposeLine___UjNzNU",
  "o1": "MacPermissionPrompt.module__actions___UjNzNU",
  "E3": "MacPermissionPrompt.module__primaryActions___UjNzNU",
  "zB": "MacPermissionPrompt.module__primary___UjNzNU",
  "qD": "MacPermissionPrompt.module__notNow___UjNzNU",
  "TQ": "MacPermissionPrompt.module__allowed___UjNzNU",
  "Wy": "MacPermissionPrompt.module__allowedIn___UjNzNU",
};

module.exports = exports;
